import React, { useEffect, useState } from 'react';
import { animated, useSpring } from 'react-spring';

const IntroView = ({ hideIntro, isId }) => {
  const [fadeOut, setFadeOut] = useState(false);
  const fadeInProps = useSpring({ opacity: 1, from: { opacity: 0 } });

  const fadeOutProps = useSpring({
    opacity: fadeOut ? '0' : '1',
  });

  useEffect(() => {
    setTimeout(() => {
      setFadeOut(true);
    }, 2800);
    setTimeout(() => {
      hideIntro(true);
    }, 3000);
  }, [hideIntro]);

  return (
    <animated.div style={fadeOutProps} className="intro">
      <section>
        <animated.div style={fadeInProps}>
          <h1 className="subtitle">{isId ? 'Akses Awal' : 'Early Access'}</h1>
          <h2 className="title">
            {isId ? 'Lebih banyak reward,' : 'More rewards,'}
            <br /> {isId ? 'dengan cara baru.' : 'in all new ways.'}
          </h2>
        </animated.div>
      </section>
    </animated.div>
  );
};

export default IntroView;
